import { jsx as c } from "react/jsx-runtime";
import { useMemo as f } from "react";
import e from "./index.es566.js";
import p from "classnames";
const x = ({
  type: i = "default",
  margin: t,
  isVertical: a,
  visible: o = !0,
  dividerLength: s = "100%",
  testId: d
}) => {
  const m = p(e.divider, e[`${i}-divider`], {
    [e.isVertical]: a
  }), l = f(() => {
    const r = {
      "--divider-length": s
    };
    return o || (r.opacity = "0"), t && (r.margin = t), r;
  }, [s, t, o]);
  return /* @__PURE__ */ c("div", { "data-testid": d, role: "separator", className: m, style: l });
};
export {
  x as Divider
};
//# sourceMappingURL=index.es18.js.map
